import store from '@/core/store';
const clearTimeouts = {};

export const clearTimeout = (name) => {
  clearTimeouts[name] && clearTimeouts[name]();
};

export const setTimeout = (cb, { name, delay }) => {
  const unsubscribe = store.subscribe((mutation, state) => {
    if (mutation.type === 'addSecondsToCurrentTime') {
      if (state.timeouts[name] && state.timeouts[name].remaining === 0) {
        cb();
        clearTimeouts[name] && clearTimeouts[name]();
      }
    }
  });
  store.registerModule(['timeouts', name], {
    state: () => ({
      remaining: delay,
      active: true,
    }),
  });
  clearTimeouts[name] = () => {
    unsubscribe();
    store.unregisterModule(['timeouts', name]);
    delete clearTimeouts[name];
  };
  return clearTimeouts[name];
};
